var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('map-card',{attrs:{"height":720,"title":'Map View: ' + _vm.title,"markers":_vm.deviceList,"categories":_vm.categoryDefs,"map-icons":_vm.mapIconDefs,"popup-headers":_vm.popupHeaders,"detail-headers":_vm.detailHeaders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }